
import { backendExceptionHandler } from "@/mixins";
import AuthService from '@/service/AuthService';

export default {
    name: "UnsubscriptionReportModal",

    mixins: [backendExceptionHandler],

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        isPersonalizedReport: {
            type: Boolean,
            default: false
        },
    },

    emits: ['input', 'success'],

    data() {
        return {
            errorMessage: null,
            isLoading: false,
        }
    },

    methods: {
        closeModal() {
            this.$emit('input', false);
        },

        async handleUnsubscribe() {
            this.isLoading = true;

            try {
                if (this.isPersonalizedReport) {
                    await AuthService.updatePersonalizedReportSubscriptionActive(this.$axios, false);
                } else {
                    await AuthService.updateGeneralReportSubscriptionActive(this.$axios, false);
                }

                this.$emit('success', this.snippetIds);
                this.$store.commit('snackbar/updateType', 'success');
                this.$store.commit('snackbar/updateMessage', this.$t('component.reportSubscription.unsubscribeSuccess'));
                this.closeModal();
            } catch (error) {
                this.handleBackendException(error, this.$t('component.reportSubscription.unsubscribeFail'));
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.errorMessage);
            } finally {
                this.isLoading = false;
            }
        },
    },
}
